module.exports = __webpack_public_path__ + "static/keyword_4-9c0c19ccd80193e68691af7c9b7a2a4d.jpg";